import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// A theme at a glance: its primary, accent, background and text colors side by side.
const ThemeSwatches = (props) => {
    return _jsx(_Fragment, { children: _jsx("span", { className: `theme-editor__swatches${props.small ? ' theme-editor__swatches--small' : ''}`, "aria-hidden": "true", children: [props.colors.Primary, props.colors.Accent, props.colors.Background, props.colors.Foreground].map((color, i) => (_jsx("span", { className: "theme-editor__swatch", style: { backgroundColor: color } }, i))) }) });
};
export default ThemeSwatches;
